module.exports = __webpack_public_path__ + "img/big2-1.d48d0134.jpg";